import React from 'react';
import glamorous from 'glamorous';
import {WEIGHT, BASE_TEXT} from '../../../../shared/style/typography';
import {FONT_FAMILY} from '../../../../shared/style/typography';
import {TARMAC} from '../../../../shared/style/colors';
import {PHONE} from '../../../../shared/style/breakpoints';
import Advert from '../../../../shared/library/advert';
import * as AD_THEMES from '../../../../shared/library/advert/themes';
import {AD_IMPRESSION} from '../../../../shared/constants/analytics';

const Container = glamorous.div({
  paddingBottom: 50,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%'
});

const Title = glamorous.h1({
  fontSize: 40,
  fontFamily: FONT_FAMILY,
  fontWeight: WEIGHT.BOLD,
  [PHONE]: {
    fontSize: 25
  }
});

const Description = glamorous.p({
  width: '100%',
  maxWidth: 544,
  textAlign: 'center',
  color: TARMAC,
  ...BASE_TEXT,
  lineHeight: 1.69
});

const AdContainer = glamorous.div({
  width: '100%',
  maxWidth: 1170,
  margin: '20px auto',
  padding: 0,
  minHeight: 110,
  ' > div': {
    margin: 0
  }
});

const Header = () => {
  return (
    <Container>
      <Title>Tool Alternatives</Title>
      <Description>
        Here are some links to the alternatives of some popular tools based on the information
        provided by the StackShare community and the tools vendors
      </Description>
      <AdContainer>
        <Advert
          placement="alternatives-banner"
          contentGroupPage="Alternatives"
          requestPath="/alternatives"
          theme={AD_THEMES.ROW}
          impressionType={AD_IMPRESSION}
        />
      </AdContainer>
    </Container>
  );
};

export default Header;
